<template>
    <div class="fill-height">
        <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="primary" dark :class="(user.role === 'Customer' ? 'px-2' : 'pr-2')">
            <v-btn icon to="/profile" v-if="user.role === 'Customer'">
                <v-icon large>mdi-account-circle</v-icon>
            </v-btn>
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-else/>
            <v-spacer/>
            <v-toolbar-title>
                <v-img class="mx-3" src="/img/logo-credireinicia-white.png" max-height="50px" contain></v-img>
            </v-toolbar-title>
            <v-spacer/>
            <v-btn icon class="mr-2" v-if="user.role === 'Support' || user.role === 'Administrator'"
                   v-show="$vuetify.breakpoint.smAndUp" :to="{ name: 'CPending' }">
                <v-badge offset-x="8" offset-y="10" overlap color="error">
                    <template v-slot:badge>{{ cs }}</template>
                    <v-icon>mdi-help-circle</v-icon>
                </v-badge>
            </v-btn>
            <v-btn icon class="mr-2" v-if="user.role === 'Checker' || user.role === 'Administrator'"
                   v-show="$vuetify.breakpoint.smAndUp" :to="{ name: 'VPending' }">
                <v-badge offset-x="8" offset-y="10" overlap color="error">
                    <template v-slot:badge>{{ cv }}</template>
                    <v-icon>mdi-alpha-v-circle</v-icon>
                </v-badge>
            </v-btn>
            <v-btn icon class="mr-2" v-if="user.role === 'Payer' || user.role === 'Administrator'"
                   v-show="$vuetify.breakpoint.smAndUp" :to="{ name: 'TPending' }">
                <v-badge offset-x="8" offset-y="10" overlap color="error">
                    <template v-slot:badge>{{ cp }}</template>
                    <v-icon>mdi-alpha-p-circle</v-icon>
                </v-badge>
            </v-btn>
            <v-btn icon v-if="user.role === 'Customer'" :to="{ name: 'Notifications' }">
                <v-badge offset-x="12" offset-y="12" overlap color="error">
                    <template v-slot:badge>{{ nt }}</template>
                    <v-icon>mdi-bell</v-icon>
                </v-badge>
            </v-btn>
        </v-app-bar>
        <v-navigation-drawer v-model="drawer" v-if="user.role !== 'Customer'" :clipped="$vuetify.breakpoint.lgAndUp" app>
            <template v-slot:prepend>
                <v-list class="pa-0">
                    <v-list-item>
                        <v-list-item-avatar size="80" style="border: 1px solid #ccc;">
                            <img :src="'/' + (user.photo ? user.photo : (user.role === 'Customer' ? 'img/photo-default.jpg' : 'img/soporte.jpg' ))" :alt="user.name">
                        </v-list-item-avatar>
                    </v-list-item>
                    <v-list-group prepend-icon="" append-icon="">
                        <template v-slot:activator>
                            <v-list-item link style="border-bottom: 1px solid #ccc; margin: 0 -15px">
                                <v-list-item-content class="py-2">
                                    <v-list-item-title>
                                        <strong>{{ user.name }}</strong>
                                    </v-list-item-title>
                                    <v-list-item-content class="success--text d-inline-block py-0" v-if="user.status === 103">Verificado
                                        <v-icon small color="success">mdi-check-circle</v-icon>
                                    </v-list-item-content>
                                    <v-list-item-content class="primary--text d-inline-block py-0" v-else-if="user.status === 102">En Revisión
                                        <v-icon small color="primary">mdi-sync-circle</v-icon>
                                    </v-list-item-content>
                                    <v-list-item-content class="error--text d-inline-block py-0" v-else-if="user.status === 104">Bloqueado
                                        <v-icon small color="error">mdi-close-circle</v-icon>
                                    </v-list-item-content>
                                    <v-list-item-content class="tertiary--text d-inline-block py-0" v-else>Sin Verificar
                                        <v-icon small color="tertiary">mdi-alert-circle</v-icon>
                                    </v-list-item-content>
                                    <v-list-item-subtitle>
                                        <strong>ID: {{ !user.id ? '' : (user.id).toString().padStart(5, 0) }}</strong>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                        <v-list-item dense class="pl-6" to="/profile/edit">
                            <v-list-item-action>
                                <v-icon>mdi-account-edit</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Editar Perfil</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item dense class="pl-6" to="/profile/password">
                            <v-list-item-action>
                                <v-icon>mdi-account-key</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Cambiar Contraseña</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                </v-list>
            </template>
            <v-divider/>
            <v-list dense class="pt-0">
                <template v-for="item in items">
                    <v-subheader v-if="item.heading" class="pl-5 grey lighten-5 grey--text text--darken-4 font-weight-black">
                        {{item.heading}}
                    </v-subheader>
                    <v-list-group v-else-if="item.children" v-model="item.model" :prepend-icon="item.icon" append-icon="mdi-menu-down">
                        <template v-slot:activator>
                            <v-list-item class="px-0">
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                        <template v-for="(child, i) in item.children">
                            <v-list-group v-if="child.children" sub-group :key="i" v-model="child.model" :prepend-icon="child.model === true ? 'mdi-arrow-down-drop-circle' : child.icon">
                                <template v-slot:activator>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ child.text }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                                <v-list-item v-for="(child2, i) in child.children" :key="i" :to="'/' + item.link + '/' + child.link + '/' + child2.link">
                                    <v-list-item-action v-if="child2.icon">
                                        <v-icon>{{ child2.icon }}</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ child2.text }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-group>
                            <v-list-item class="pl-6" :key="i" :to="'/' + item.link + '/' + child.link" v-else>
                                <v-list-item-action v-if="child.icon">
                                    <v-icon>{{ child.icon }}</v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>{{ child.text }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-list-group>
                    <v-list-item v-else-if="item.link === 'logout'" @click="logout()">
                        <v-list-item-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-else :to="'/' + item.link">
                        <v-list-item-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-list>
        </v-navigation-drawer>
        <v-main :class="(user.role === 'Customer' ? 'mb-14': '')">
            <transition name="fade" mode="out-in">
                <router-view
                    :user="user"
                    :items="notifications"
                    @success="update"
                    @update="getNotifications"
                />
            </transition>
        </v-main>
        <v-bottom-navigation grow fixed dark background-color="primary" color="secondary" v-show="user.role === 'Customer'">
            <v-btn class="px-1" to="/">
                <span>Inicio</span>
                <v-icon>mdi-apps</v-icon>
            </v-btn>
            <v-btn class="px-1" to="/services">
                <span>Servicios</span>
                <v-icon>mdi-format-list-bulleted</v-icon>
            </v-btn>
            <v-btn class="px-1" to="/payments">
                <span>Pagos</span>
                <v-icon>mdi-cash-multiple</v-icon>
            </v-btn>
            <v-btn class="px-1" to="/tickets">
                <span>Soporte</span>
                <v-icon>mdi-account-cog</v-icon>
            </v-btn>
        </v-bottom-navigation>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import axios from 'axios';
    import Form from '../helpers/form';
    import { getUA, isIOS, isAndroid } from 'mobile-device-detect';

    export default {
        name: "AdminComponent",
        mixins: [ Form ],
        data: () => ({
            loading: true,
            useragent: getUA,
            iOS: isIOS,
            Android: isAndroid,
            drawer: null,
            countries: [
                { name: 'Brasil', code: 'BRA' },
                { name: 'Chile', code: 'CHL' },
                { name: 'Colombia', code: 'COL' },
                { name: 'Ecuador', code: 'ECU' },
                { name: 'Mexico', code: 'MEX' },
                { name: 'Panama', code: 'PAN' },
                { name: 'Peru', code: 'PER' },
                { name: 'Estados Unidos', code: 'USA' },
                { name: 'Venezuela', code: 'VEN' }
            ],
            user: {
                id: null,
                photo: null,
                name: null,
                lname: null,
                country: 'COL',
                role: 'Customer',
                status: null,
                suspendReason: null
            },
            notifications: [],
            nt: '0',
            cs: '0',
            cv: '0',
            cp: '0',
            show: true,
            c: false,
            t: false
        }),
        mounted() {
            console.log(this.user, this.auth)
            this.user = Object.assign(this.user, this.auth);
            this.getNotifications();
            this.getCountChecker();
        },
        computed: {
            ...mapGetters({
                auth: 'user'
            }),
            items() {
                const role = this.user.role;
                let menu = [
                    { icon: 'mdi-view-dashboard', text: 'Inicio', link: '' }
                ];

                if (role === 'Administrator') {
                    menu.push(
                        {
                            icon: 'mdi-alert-circle-check', text: 'Verificador', link: 'checker', children: [
                                { icon: 'mdi-minus-circle', text: 'Pendientes', link: 'pending' },
                                { icon: 'mdi-check-circle', text: 'Aprobadas', link: 'approved' },
                                { icon: 'mdi-close-circle', text: 'Rechazadas', link: 'rejected' },
                                { icon: 'mdi-alert-circle', text: 'Abandonadas', link: 'abandoned' }
                            ]
                        },{
                            icon: 'mdi-swap-horizontal-circle', text: 'Procesos', link: 'process', children: [
                                { icon: 'mdi-minus-circle', text: 'Pendientes', link: 'pending' },
                                { icon: 'mdi-alert-circle', text: 'Asignados', link: 'assigned' },
                                { icon: 'mdi-check-circle', text: 'Completados', link: 'completed' }
                            ]
                        },{
                            icon: 'mdi-forum', text: 'Soporte', link: 'support', children: [
                                { icon: 'mdi-alert-circle', text: 'Por Responder', link: 'pending' },
                                { icon: 'mdi-check-circle', text: 'Respondidos', link: 'responded' },
                                { icon: 'mdi-close-circle', text: 'Cerrados', link: 'closed' }
                            ]
                        }
                    )
                }
                if (role === 'Support') {
                    menu.push(
                        { heading: 'SOPORTE' },
                        { icon: 'mdi-alert-circle', text: 'Por Responder', link: 'support/pending' },
                        { icon: 'mdi-check-circle', text: 'Respondidos', link: 'support/responded' },
                        { icon: 'mdi-close-circle', text: 'Cerrados', link: 'support/closed' },
                    )
                }
                if (role === 'Administrator' || role === 'Auditor' || role === 'Support') {
                    menu.push(
                        {heading: 'REPORTES'},
                        {icon: 'mdi-file-chart', text: 'Reporte General', link: 'reports/general'},
                        {icon: 'mdi-finance', text: 'Reporte Completadas', link: 'reports/completed'},
                        {icon: 'mdi-office-building', text: 'Reporte Oficinas', link: 'reports/offices'}
                    )
                }
                if (role === 'Administrator' || role === 'Auditor') {
                    menu.push(
                        { heading: 'CONTABILIDAD' },
                        { icon: 'mdi-format-list-text', text: 'Inventario', link: 'movements/accounts' },
                        { icon: 'mdi-contrast-circle', text: 'Traslados', link: 'movements/transfer' },
                        { icon: 'mdi-file-tree', text: 'Entradas/Salidas', link: 'movements/in-out' },
                    )
                }
                if (role === 'Checker' || role === 'Cashier' || role === 'Payer' || role === 'Monitor') {
                    menu.push({ heading: 'TRANSACCIONES' })
                }
                if (role === 'Checker') {
                    menu.push(
                        { icon: 'mdi-minus-circle', text: 'Pendientes', link: 'checker/pending' },
                        { icon: 'mdi-check-circle', text: 'Aprobadas', link: 'checker/approved' },
                        { icon: 'mdi-close-circle', text: 'Rechazadas', link: 'checker/rejected' }
                    )
                }
                if (role === 'Payer') {
                    menu.push(
                        { icon: 'mdi-minus-circle', text: 'Pendientes', link: 'process/pending' },
                        { icon: 'mdi-check-circle', text: 'Realizadas', link: 'process/approved' },
                        { icon: 'mdi-contrast-circle', text: 'Traslados', link: 'inventory/transfer' }
                    )
                }
                if (role === 'Monitor') {
                    menu.push(
                        { icon: 'mdi-check-circle', text: 'Aprobadas', link: 'checker/approved' },
                        { heading: 'USUARIOS' },
                        { icon: 'mdi-account-multiple', text: 'Clientes', link: 'users/customers' }
                    )
                }
                if (role === 'Administrator') {
                    menu.push(
                        { heading: 'PANEL DE CONTROL' },
                        {
                            icon: 'mdi-account-group', text: 'Usuarios', link: 'users', children: [
                                { icon: 'mdi-account-multiple', text: 'Clientes', link: 'customers' },
                                { icon: 'mdi-account-tie', text: 'Empleados', link: 'staff' }
                            ]
                        },{
                            icon: 'mdi-cog-transfer', text: 'Ajustes', link: 'settings', children: [
                                { icon: 'mdi-bank', text: 'Medios de Pago', link: 'gateways' },
                                { icon: 'mdi-circle-multiple', text: 'Paquetes', link: 'plans' },
                                { icon: 'mdi-sack-percent', text: 'Cupones', link: 'coupons' },
                                { icon: 'mdi-scale-balance', text: 'Legal', link: 'legal' },
                            ]
                        }
                    )
                }
                if (role === 'Cashier' || role === 'Support' || role === 'Monitor') {
                    menu.push({ icon: 'mdi-information', text: 'Información', link: 'about' })
                }
                menu.push({ icon: 'mdi-exit-to-app', text: 'Cerrar Sesion', link: 'logout' })

                return menu;
            }
        },
        methods: {
            async logout() {
                await this.$store.dispatch("logout");
                this.$toast.info('Has cerrado sesion correctamente.', { icon: 'mdi-information' });
                await this.$router.push({name: "Login"});
            },
            getNotifications() {
                clearTimeout(this.countNotifications);
                axios.get('/api/notifications').then((res) => {
                    this.nt = res.data.count;
                    this.notifications = res.data.items;
                }).catch(err => {
                    this.handleErrors(err.response.data.errors);
                });
                this.countNotifications = setTimeout(this.getNotifications, 60000);
            },
            getCountChecker() {
                clearTimeout(this.countChecker);
                axios.get('/api/checker/count').then((res) => {
                    if (res.data.v === 'success') {
                        this.cs = res.data.cs;
                        this.cv = res.data.cv;
                        this.cp = res.data.cp;
                    } else {
                        this.$toast.error(res.data.status, {icon: 'mdi-close-circle'});
                    }
                }).catch(err => {
                    this.handleErrors(err.response.data.errors);
                });
                this.countChecker = setTimeout(this.getCountChecker, 30000);
            },
            update() {
                axios.get('/api/profile').then((res) => {
                    this.user = res.data.user;
                    this.$store.dispatch('setUser', res.data);
                    if (this.user.status !== 103) {
                        clearTimeout(this.timeout);
                        this.timeout = setTimeout(this.update, 300000);
                    }
                }).catch(err => {
                    this.handleErrors(err.response.data.errors);
                });
            }
        },
        destroyed() {
            clearTimeout(this.timeout);
            clearTimeout(this.countNotifications);
            clearTimeout(this.countChecker);
        }
    }
</script>

<style scoped>
.list-custom{
    min-height: 48px;
    max-height: 448px;
    overflow-y: auto;
    padding: 0;
}
.v-item-group.v-bottom-navigation .v-btn {
    min-width: 64px;
}
</style>
